import { Component, OnInit, Input } from '@angular/core';
import { SDTK } from 'src/app/model/quote/sdtk/sdtk.model';
import { ActivatedRoute, Router } from '@angular/router';
import { SDTKService } from './sdtk.service';
import { UserInfoService } from '../../services/user-info.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-sdtk',
  templateUrl: './sdtk.component.html',
  styleUrls: ['./sdtk.component.css']
})
export class SdtkComponent implements OnInit {
  authDetails = '';
  selectedIndex = 0;
  @Input() quote;
  fullDetailsTab = false;
  statementOfFactsTab = false;
  paymentDetails = false;
  submission = false;
  staticData;
  excessProtectOptions;
  apiModelObject;
  modelObject = new SDTK();
  urlID = this.route.snapshot.params.id;
  quote_type: number = this.route.snapshot.params.quote_type ? this.route.snapshot.params.quote_type : 1;
  unlockedTabIndex: number = 0

  constructor(private sdtkService: SDTKService,
    private route: ActivatedRoute,
    private router: Router,
    private userInfoService: UserInfoService) {
  }


  ngOnInit(): void {
    this.userInfoService.getUserDetails();
    this.getSDTKData();
    this.getAccessToken();
    if (this.route.snapshot.params.id) {
      this.unlockedTabIndex = 2; // all tabs enabled
    }
  }
  getAccessToken() {
    const data = {
      client_id: environment.AMLINE_CLIENT_ID,
      client_secret: environment.AMLINE_CLIENT_SECRET,
      grant_type: environment.AMLINE_GRANT_TYPE,
      scope: environment.AMLINE_SCOPE,
    };
    this.sdtkService.getAccessToken(data)
      .subscribe(
        (response: any) => {
          if (response.access_token) {
            //this.authDetails = response;
            this.getStaticData(response);
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }
  getStaticData(response) {
    this.sdtkService.getStaticData(response)
      .subscribe(
        (response: any) => {
          if (response.meta) {
            this.staticData = response.meta;
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }
  modelObjectUpdated(data) {
    this.modelObject = null;
    this.modelObject = data;
    this.getSDTKData(data.id);
    //this.selectedIndex += 1;
    console.log(this.selectedIndex);
    // Unlock the next tab each time a tab saves
    if (this.selectedIndex >= this.unlockedTabIndex) {
      this.unlockedTabIndex = this.selectedIndex + 1;
    }
    this.selectedIndex += 1;
  }
  tabChanged(index: number) {
  }
  getSDTKData(id = '') {
    if (this.route.snapshot.params.id) {
      let quote_id = this.route.snapshot.params.id;
      let temp_modelObj = this.modelObject;
      if (id) {
        quote_id = id;
      }
      this.sdtkService.getSDTKData(quote_id)
        .subscribe(
          (response: any) => {
            if (response.result) {
              this.apiModelObject = response.result.quote_data.quote_versions[0];
              this.modelObject = response.result.quote_data.quote_versions[0];
              if (this.quote_type == 4) {
                let res_quote = response.result.quote_data.quote_versions.filter(x => x.id == this.route.snapshot.params.id);
                this.apiModelObject = res_quote[0];
                this.modelObject = res_quote[0];
              }


              if (response.result.quote_data.quote_versions[0].status == "referred") {
                this.router.navigate(['/sdtk/quote-details/', this.route.snapshot.params.id]);
              }
            }
          },
          (error) => {
            console.log(error);
          }
        );
    }
  }
  onBackFromQuotation(updatedModel: any) {
    this.modelObject = updatedModel;   // IMPORTANT
    this.selectedIndex = this.selectedIndex - 1;
  }
}
